import React, {useRef, useState} from 'react';
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {useForm} from "react-hook-form";

// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {ProductPromotionList} from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ButtonCancel, ButtonSubmit} from "../../../components/buttons/buttonsActions";
import {connect} from "react-redux";

// components
import {showToastCustom} from "../../../components/toast/customToast";

// providers
import {productProvider} from "../../../providers/productProvider";

// actions
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/promotionActions";

// services
import {productPromotionService} from "../../../jwt/_services/promotions/productPromotionService";

// labels
import {error, selectOption} from "../../../components/i18n/i18n";


const ProductPromotion = (props) => {
    const { domainObject } = props.formProps;
    const { app } = props.mainProps
    // MAIN props
    const fbDataBaseId = app?.fbDataBase?.id;
    const [promotion] = useState( domainObject);
    const [editMode, setEditMode] = useState(false);
    const [itemToEdit, setItemToEdit] = useState();

    const refList = useRef(null);

    // FORM props
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(true);
    const [samePromotionStatus, setSamePromotionStatus] = useState(null);
    const [packageId, setPackageId] = useState(null);
    const [productId, setProductId] = useState(null);
    const [productSubstituteId, setProductSubstituteId] = useState(null);

    const [resetValues, setResetValues] = useState( false )





    const [childs, setChilds] = useState([])




    const {register, handleSubmit, reset} = useForm({});

    const setForm = (_editMode, _itemToEdit) => {
        setEditMode(_editMode);
        setItemToEdit(_itemToEdit);

        if (_itemToEdit) {
            setStatus(_itemToEdit.status);
            setSamePromotionStatus(_itemToEdit?.samePromotionStatus );
            setPackageId( _itemToEdit.packageId != null ? _itemToEdit.packageId : '' );
            setProductId(_itemToEdit?.product?.id );
            setProductSubstituteId(_itemToEdit?.productSubstitute?.id || null)
        } else {
            setStatus(false);
            setSamePromotionStatus(null );
            setPackageId(null);
            setProductId(null);
            setProductSubstituteId(null)
        }
    }

    const onSubmit = (data, _) => {
        if ( productId === null || productId === undefined || productId === '')
            return showToastCustom(error, selectOption);

        const dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id: itemToEdit?.id,
                packageId: packageId,
                status: status,
                samePromotionStatus: samePromotionStatus,
                product: { id : productId },
                promotion: { id : promotion?.id },
            }
        };

        if (productSubstituteId !== null && productSubstituteId !== undefined && productSubstituteId !== '')
            dataRequest.item.productSubstitute = { id : productSubstituteId }
        else
            dataRequest.item.productSubstitute = null

        setLoading(true);

        if (!editMode)
            productPromotionService.saveItem(dataRequest)
                .then(_ => resetForm())
                .finally(()=> setLoading(false))
        else
            productPromotionService.updateItem(itemToEdit.id, dataRequest)
                .then(_ => resetForm())
                .finally(()=> setLoading(false))

    };

    const resetForm = () => {
        setEditMode(false);
        setItemToEdit(null);
        setStatus(false);
        setPackageId(null);
        setProductSubstituteId(null)
        setResetValues(!resetValues)
        refList.current.refreshList();
        reset();
    }

    const closeForm = () => {
        props.setItem(null);
        props.setForm();
        props.setViewMode("LIST");
    }
    //props.setFormPromotion(false, null, 'LIST');


    const handleChilds = val => setChilds(val.map( v => v?.id))

    return <>
            {loading && showLoader()}
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <Card>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="fas fa-box-open mr-2"/>
                            Productos de la promocion { promotion.code  ? " : " + promotion.code : "" }
                        </CardTitle>
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Producto</Label>
                                            {
                                                editMode ?
                                                    <Input type="text" name="product"
                                                           value={ itemToEdit.productSivexCode + " - " + itemToEdit.productName }
                                                           innerRef={register}
                                                           disabled={true}
                                                    />
                                                    :
                                                    <SelectGeneric
                                                        initialValue={ productId }
                                                        setExternalValue={ setProductId }
                                                        provider = { productProvider }
                                                        resetValue = { resetValues }
                                                        itemsToExclude={childs}
                                                    />
                                            }
                                        </FormGroup>
                                    </Col>

                                    <Col md="2">
                                        <FormGroup>
                                            <Label>Activo</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    value={status}
                                                    onChange={() => setStatus(!status)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>{'Mantener mistmo estatus que la promoción'}</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    value={samePromotionStatus}
                                                    onChange={() => setSamePromotionStatus(!samePromotionStatus)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Producto subsituto</Label>
                                                <SelectGeneric
                                                    initialValue={ productSubstituteId }
                                                    setExternalValue={ setProductSubstituteId }
                                                    provider = { productProvider }
                                                    resetValue = { resetValues }
                                                />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Id del paquete</Label>
                                            <Input type="text" name="packageId"
                                                   placeholder="Ingrese id de paquete."
                                                   innerRef={register}
                                                   value={packageId}
                                                   onChange={e => setPackageId(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <CardBody className="border-top">
                                    <div className="float-right">
                                        <ButtonSubmit/>
                                        <ButtonCancel onClick={closeForm}/>
                                    </div>
                                </CardBody>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col>
                    <ProductPromotionList
                        setForm={setForm}
                        promotion={promotion}
                        setLoading={ (l) => setLoading(l) }
                        ref={refList}
                        app={ app }
                        handleChilds = { handleChilds }
                    />
                </Col>
            </Row>
        </>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ProductPromotion)
